/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

     let flg = 0;
    const $vanillaAccordion = $('.accordion');
    const $faqHeading = $('.accordion > dt > a');
    $('.accordion > dd').attr('aria-hidden', true);
    $faqHeading.attr('aria-expanded', false);

    $faqHeading.on('click activate',function () {
      if (flg) return false;
      flg = 1;
      const state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded', state);
      $(this).parent().next().slideToggle(() => {
        flg = 0;
      });
      $(this).parent().next().attr('aria-hidden', !state);
      return false;
    });
    $faqHeading.on('keydown',function (event) {
      const keyCode = event.keyCode || event.which;
      if (keyCode === 13) {
        $(this).trigger('activate');
      }
    });

     $vanillaAccordion.each((_, accordion) => {
  const $accordion = $(accordion);

  if ($accordion.data('state') === 'open') {
    $accordion.children('dt').slice(0, 2).children('a')
      .attr('aria-expanded', 'true')
      .parent().next('dd')
      .attr('aria-hidden', 'false')
      .show();
  }
});
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
  // Mobile touch swipe for product media gallery
  function initProductSwipe() {
    const mediaContainers = document.querySelectorAll('product-images, [data-section-type] .product__media-container, [data-section-type] .product-images');
    mediaContainers.forEach(function(container) {
      let touchStartX = 0, touchStartY = 0, touchEndX = 0, touchEndY = 0;
      const minSwipeDistance = 50;
      container.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
      }, { passive: true });
      container.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        touchEndY = e.changedTouches[0].screenY;
        const deltaX = touchEndX - touchStartX;
        const deltaY = touchEndY - touchStartY;
        if (Math.abs(deltaX) < minSwipeDistance || Math.abs(deltaX) < Math.abs(deltaY)) return;
        const section = container.closest('[data-section-type]');
        if (!section) return;
        const thumbs = section.querySelectorAll('[data-thumb-item]');
        if (!thumbs.length) return;
        const activeThumb = section.querySelector('[data-thumb-item].is-active');
        let currentIndex = 0;
        thumbs.forEach(function(thumb, index) { if (thumb === activeThumb) currentIndex = index; });
        const nextIndex = deltaX < 0 ? (currentIndex + 1) % thumbs.length : (currentIndex - 1 + thumbs.length) % thumbs.length;
        const nextLink = thumbs[nextIndex].querySelector('[data-thumb-link]');
        if (nextLink) nextLink.click();
      }, { passive: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductSwipe);
  } else {
    initProductSwipe();
  }
  document.addEventListener('shopify:section:load', initProductSwipe);

  function initSwitchMegaMenus(root) {
    (root || document).querySelectorAll('[data-switch-mega]').forEach(function(menu) {
      if (menu.dataset.switchMegaReady === 'true') return;
      menu.dataset.switchMegaReady = 'true';

      const triggers = Array.from(menu.querySelectorAll('[data-switch-trigger]'));
      const panels = Array.from(menu.querySelectorAll('[data-switch-panel]'));

      function activate(index) {
        triggers.forEach(function(trigger) {
          const active = trigger.dataset.switchTrigger === index;
          trigger.classList.toggle('is-active', active);
          if (active) trigger.setAttribute('aria-current', 'true');
          else trigger.removeAttribute('aria-current');
        });

        panels.forEach(function(panel) {
          const active = panel.dataset.switchPanel === index;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      }

      triggers.forEach(function(trigger) {
        const switchPanel = function() { activate(trigger.dataset.switchTrigger); };
        trigger.addEventListener('mouseenter', switchPanel);
        trigger.addEventListener('focus', switchPanel);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initSwitchMegaMenus(document); });
  } else {
    initSwitchMegaMenus(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initSwitchMegaMenus(event.target);
  });
